import React from 'react'
import { Button, Input } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';

class TimeTrackingNewEntry extends React.Component {

    render = () => {
        this.props.info('TimeTrackingNewEntry.js/render');
        return (
            <>
                {this.props.addTaskTimeTrackingId === this.props.taskId && this.props.workflowId === this.props.addWorkflowId ?
                    <>
                        <tr>
                            <td className="px-1 pb-1">
                                <Input
                                    type={this.props.daily ? "date" : "date" /*"month"*/}
                                    name={"date"}
                                    value={this.props.isFieldNull(this.props.addTaskTimeTracking.date)}
                                    onChange={(e) => this.props.onChange(e)}
                                />
                            </td>
                            <td className="px-1 pb-1">
                                <Input
                                    type="time"
                                    name={"beginTimestamp"}
                                    value={this.props.isFieldNull(this.props.addTaskTimeTracking.beginTimestamp)}
                                    disabled={this.props.addTaskTimeTracking.userSetDuration}
                                    onChange={(e) => this.props.onChange(e)}
                                />
                            </td>
                            <td className="px-1 pb-1">
                                <Input
                                    type="time"
                                    name={"endTimestamp"}
                                    value={this.props.isFieldNull(this.props.addTaskTimeTracking.endTimestamp)}
                                    disabled={this.props.addTaskTimeTracking.userSetDuration}
                                    onChange={(e) => this.props.onChange(e)}
                                />
                            </td>
                            <td className="px-1 pb-1">
                                <Input
                                    type="number"
                                    name={"duration"}
                                    value={this.props.isFieldNull(this.props.addTaskTimeTracking.duration)}
                                    disabled={this.props.addTaskTimeTracking.userPreventSetDuration}
                                    onChange={(e) => this.props.onChange(e)}
                                    min={0}
                                    max={24}
                                />
                            </td>
                            <td className="px-1 pb-1">
                                <Button
                                    color="success"
                                    disabled={this.props.addTaskTimeTracking.date === '' || ((this.props.addTaskTimeTracking.duration === '' || this.props.addTaskTimeTracking.duration <= 0) && this.props.requireHours)}
                                    onClick={this.props.onHandleAdd}
                                >
                                    <FontAwesomeIcon icon={faPlus} />
                                </Button>
                                <Button color="secondary" onClick={() => this.props.cb({ addTaskTimeTrackingId: 0, addWorkflowId: 0 })}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </Button>
                            </td>
                        </tr>
                        <tr>
                            <td className="border-top-0 pt-0 px-1">
                                <Input
                                    type="select"
                                    name="employeeId"
                                    value={this.props.isFieldNull(this.props.addTaskTimeTracking.employeeId)}
                                    onChange={(e) => this.props.onChange(e)}>
                                    <option value={0}>Select Employee</option>
                                    {this.props.employees.filter(employee => employee.active).sort((a, b) => a.lastName.localeCompare(b.lastName)).map(employee => (
                                        <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.lastName}, {employee.firstName} </option>
                                    ))}
                                </Input>
                            </td>
                            <td colSpan={3} className="border-top-0 pt-0 px-1">
                                <Input
                                    type="textarea"
                                    placeholder="Notes"
                                    rows={4}
                                    name={"notes"}
                                    value={this.props.isFieldNull(this.props.addTaskTimeTracking.notes)}
                                    onChange={(e) => this.props.onChange(e)}
                                />
                            </td>
                            <td className="border-top-0 pt-0 px-1"></td>
                        </tr>
                    </>
                    : <></>
                }
            </>

        )
    }
}

export default TimeTrackingNewEntry;